<div class="rate-details-line">
  <div class="rate-cell" *ngFor="let col of details">
    <span class="rate-cell__title">{{col.title}} </span>
    <span class="rate-cell__value">{{col.value}}</span>
  </div>
</div>
